
































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Hamburger extends Vue {
    @Prop() menuItems!: any;

    open = false;

    mounted() {}
}
